import { createTheme } from '@mui/material';

const theme = createTheme({
  cssVariables: true,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          fontFamily: "'Twemoji', 'Fira Sans', sans-serif",
        },
      },
    },
  },
  palette: {
    primary: {
      light: '#3B4045',
      main: '#20252B',
      dark: '#121518',
    },
    secondary: {
      light: '#EC5472',
      main: '#E3002C',
      dark: '#B10022',
    },
  },
});

export default theme;
